module.exports = __webpack_public_path__ + "assets/65820082ed9a02a090cbaa1ce2a91750.png";